// Port of api/fuel/app/classes/insights/size/compare.php

import Segment from 'offline/insights/segment'
import Constants from 'offline/constants'
import Config from 'offline/model/config'
import Util from 'offline/util'

function excludeExpansions(ownerId) {
	var config = Config.user(ownerId)
	return !!(((config || {}).insights || {}).size || {}).expansions
}

function histogram(collectionSizes, self) {
	var bucketCount = 25
	var position = 0
	var filtered = collectionSizes.filter(function(value) { return value > 0 })
	if (!filtered.length) return { position: 0, labels: [], data: [] }
	var maxCollectionSize = Math.max.apply(null, filtered)
	var minCollectionSize = Math.min.apply(null, filtered)
	var logMin = Math.log(minCollectionSize) / Math.log(10)
	var logMax = Math.log(maxCollectionSize) / Math.log(10)
	var bucketSize = (logMax - logMin) / bucketCount
	var data = Array(bucketCount).fill(0)
	var labels = []

	for (var i = 0; i < bucketCount; i++) {
		var bucketMin = Math.round(Math.pow(10, logMin + (bucketSize * i)))
		var bucketMax = Math.round(Math.pow(10, logMin + (bucketSize * (i + 1)))) - 1
		for (var j = 0; j < filtered.length; j++) if (filtered[j] >= bucketMin && filtered[j] < bucketMax + 1) data[i]++
		labels[i] = bucketMin !== bucketMax ? (bucketMin + '-' + bucketMax + ' games') : (bucketMin + ' game' + (bucketMin > 1 ? 's' : ''))
		if (self >= bucketMin && self <= bucketMax) position = i
	}

	return { position: position, labels: labels, data: data }
}

function uniqueSortedCounts(rows) {
	var index = {}
	for (var i = 0; i < rows.length; i++) {
		var value = parseInt(rows[i].v, 10) || 0
		if (value > 0) index[value] = value
	}
	return Object.keys(index).map(function(key) {
		return parseInt(key, 10)
	}).sort(function(a, b) {
		return a - b
	})
}

export default Segment.extend({
	name: 'compare',
	types: [Constants.TYPE_USER],
	insight: false,
	detail: false,
	run: function(type, owner, userIndex, detail, filter, vars) {
		var fieldCount = excludeExpansions(vars && vars.sessionUserId) ? 'user_count_collection_games' : 'user_count_collection'
		// Raw query rather than User.collection() to avoid instantiating
		// 70k+ Model objects when scanning the user table for the
		// community size histogram. The games/compare segment uses the
		// same pattern.
		var sizes = uniqueSortedCounts(Util.queryFast(
			'SELECT ' + fieldCount + ' AS v FROM user WHERE ' + fieldCount + ' > 0 ORDER BY ' + fieldCount + ' ASC'
		))
		var selfValue = parseInt(owner.get(fieldCount), 10) || 0

		return {
			compare: {
				histogram: histogram(sizes, selfValue),
				metrics: {
					percentile: Util.percentile(sizes, selfValue),
					median: selfValue - Util.median(sizes)
				}
			}
		}
	}
})
